import { colorMix } from 'src/theme/color-palettes';

export default {
  css: ({ dt }) => {
    return `.p-datatable > .p-overlay-mask { background: ${colorMix(dt('gray.300'), 30)}; color: ${dt('text-color')}; } .p-datatable-tbody > tr:last-child > td { border-bottom:0; }`;
  },
};
